var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { ref: "mask", staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { ref: "modal", staticClass: "modal-container" }, [
          _c(
            "div",
            { staticClass: "modal-header" },
            [
              _vm._t("header", function () {
                return [
                  _c("span", { staticClass: "header-title" }, [
                    _vm._v(_vm._s(_vm.headerTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "header-close-icon",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times-circle" })]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._t("body", function () {
                return [_vm._v("\n            default body\n          ")]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm._t("footer", function () {
                return [
                  _c(
                    "a",
                    {
                      staticClass:
                        "modal-default-button cancel-button btn btn-default excluded",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.cancelLabel))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "modal-default-button ok-button btn btn-primary excluded",
                      attrs: { disabled: _vm.submitDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("submit")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.submitLabel))]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }